import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ListLeadsFilter, ListLeadsResponse } from 'src/app/class/datatype';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LeadsService {
  constructor(private http: HttpClient) {}

  list(filter: ListLeadsFilter): Observable<ListLeadsResponse> {
    let params = new HttpParams();

    if (filter.startDate) {
      params = params.append('startDate', filter.startDate.toString());
    }

    if (filter.endDate) {
      params = params.append('endDate', filter.endDate.toString());
    }

    if (filter.name) {
      params = params.append('name', filter.name.toString());
    }

    if (filter.phone) {
      params = params.append('phone', filter.phone.toString());
    }

    if (filter.status) {
      params = params.append('status', filter.status.toString());
    }

    params = params.append('page', filter.page.toString());
    params = params.append('per_page', filter.per_page.toString());

    return this.http.get<ListLeadsResponse>(
      environment.apiUrl + 'clientapi/leads',
      { params }
    );
  }
}
